import { Link } from 'react-router-dom';

const Contact = () => {
  return (
    <div className="page-container">
      <Link to="/" className="back-button">← Back to Home</Link>
      
      <h1>Contact Us</h1>
      <div className="content-card">
        <div className="contact-info">
          <div className="contact-item">
            <h4>Social Media</h4>
            <div className="social-links">
              <a 
                href="https://x.com/hi_kaank" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                𝕏 @hi_kaank
              </a>
            </div>
          </div>

          <div className="contact-item">
            <h4>Email</h4>
            <a 
              href="mailto:support@langshazam.com"
              className="social-link email-link"
            >
              ✉ support@langshazam.com
            </a>
          </div>

          <div className="contact-item">
            <h4>Get in Touch</h4>
            <p>We'd love to hear from you! Whether you have questions about our language detection service or want to provide feedback, feel free to reach out through any of the channels above.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 